<div [class.dark-theme]="true" class="fix-action-dialog">
	<mat-dialog-content fxLayout="column">
		<ng-container>

			<div class="fix-action-dialog">
				<h2 mat-dialog-title style="font-size: 14px;color:#ffffff;font-weight: 600;"><span translate>管理アカウント</span></h2>
			</div>

			<mat-card>
				<mat-card-content>
					<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
						<div fxLayout="column">

							<mat-form-field appearance="outline" style="margin:6px;height: 80px;">
								<mat-label><span translate>送信先メールアドレス</span></mat-label>
								<input #username="ngModel" (blur)="toNickname()" [(ngModel)]="content.username" autocomplete="off" email matInput maxlength="255" minlength="3" name="username" placeholder="{{'メールアドレス'| translate}}" required type="email">
								<mat-error *ngIf="username.errors?.['email'];"><span translate>有効なメールアドレスを入力してください</span></mat-error>
								<mat-error *ngIf="username.errors?.['required'];"><span translate>入力してください</span></mat-error>
								<mat-error *ngIf="username.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
								<mat-error *ngIf="username.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
							</mat-form-field>

							<mat-form-field appearance="outline" style="margin:6px;height: 80px;">
								<mat-label><span translate>お名前</span></mat-label>
								<input #nickname="ngModel" [(ngModel)]="content.nickname" autocomplete="off" matInput maxlength="100" minlength="3" name="nickname" placeholder="{{'お名前'| translate}}" required type="text">
								<mat-hint><span translate>3文字以上100文字まで</span></mat-hint>
								<mat-error *ngIf="nickname.errors?.['required'];"><span translate>入力してください</span></mat-error>
								<mat-error *ngIf="nickname.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
								<mat-error *ngIf="nickname.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
							</mat-form-field>

							<mat-form-field appearance="outline" style="margin:6px;height: 80px;">
								<mat-label><span translate>パスワード</span></mat-label>
								<input #password="ngModel" [(ngModel)]="content.password" matInput maxlength="1000" minlength="6" name="password" placeholder="{{'パスワード'| translate}}" required type="password">
								<mat-hint><span translate>6文字以上1000文字まで</span></mat-hint>
								<mat-error *ngIf="password.errors?.['required'];"><span translate>入力してください</span></mat-error>
								<mat-error *ngIf="password.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
								<mat-error *ngIf="password.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
							</mat-form-field>

							<mat-form-field appearance="outline" style="margin:6px;height: 80px;">
								<mat-label><span translate>パスワード（確認）</span></mat-label>
								<input #confirm_password="ngModel" [(ngModel)]="content.confirm_password" [validateEquals]="password" matInput name="confirm_password" placeholder="{{'パスワード(確認)'| translate}}" required type="password">
								<mat-hint><span translate>6文字以上1000文字まで</span></mat-hint>
								<mat-error *ngIf="confirm_password.errors?.['required'];"><span translate>確認用パスワードを入力してください</span></mat-error>
								<mat-error *ngIf="confirm_password.errors?.['validateEquals']"><span translate>確認用パスワードが一致しません</span></mat-error>
							</mat-form-field>

							<ng-container>
								{{completeMessage}}
							</ng-container>
						</div>
					</form>
				</mat-card-content>
			</mat-card>
		</ng-container>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around" style="margin:6px;">
		<button [disabled]="isProgress" color="warn" mat-dialog-close="" mat-stroked-button id="mat-cancel-button">キャンセル</button>
		<button (click)="onAccept()" *ngIf="!(form.invalid || isProgress)" [disabled]="form.invalid || isProgress" color="primary" mat-raised-button id="mat-regist-mail-button"><span translate>登録メールを送信</span></button>
		<button *ngIf="(form.invalid || isProgress)" [disabled]="isProgress" cdkFocusInitial color="primary" mat-raised-button style="background-color:#B0D296; color: #F4F7F1;" id="mat-regist-mail-send-button"><span translate>登録メールを送信</span></button>
	</mat-dialog-actions>
</div>
